module.exports = __webpack_public_path__ + "img/H01121-70.2ce6f804.jpg";